import patch from './patch';

export default value => (dispatch, _getState) => {
  dispatch(patch({
    ui: { inputLocation: value },
  }));
};
